<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:60vh;font-family:sans-serif;">
  <ng-container [ngSwitch]="status">
    <ng-container *ngSwitchCase="'loading'">
      <p>Connecting your Stripe account...</p>
    </ng-container>
    <ng-container *ngSwitchCase="'success'">
      <p style="color:#28a745;font-size:1.2rem;">&#10003; Stripe connected successfully! Redirecting...</p>
    </ng-container>
    <ng-container *ngSwitchCase="'error'">
      <p style="color:#dc3545;font-size:1.2rem;">&#10007; {{ errorMessage }}</p>
      <a routerLink="/clinic/settings" style="margin-top:1rem;">Go back to Settings</a>
    </ng-container>
  </ng-container>
</div>
